import { LayoutDashboard, Package, ArrowLeftRight, ShoppingCart, ListChecks, CalendarDays, DoorOpen, Bell, FileDown, Users, Settings, History, CalendarRange, ShieldCheck, UserCircle, Receipt, Wallet, FolderOpen, BarChart3, ScrollText } from "lucide-react";

export const NAV = [
  { to: "/", label: "Home", icon: LayoutDashboard },
  { to: "/inventario", label: "Inventario", icon: Package, perm: ["inventory", "view"] },
  { to: "/movimenti", label: "Entrate e uscite", icon: ArrowLeftRight, perm: ["movements", "view"] },
  { to: "/spesa", label: "Lista della spesa", icon: ShoppingCart, perm: ["shopping", "view"] },
  { to: "/compiti", label: "Attività e compiti", icon: ListChecks, perm: ["tasks", "view"] },
  { to: "/eventi", label: "Eventi", icon: CalendarDays, perm: ["events", "view"] },
  { to: "/sale", label: "Sale e prenotazioni", icon: DoorOpen, perm: ["bookings", "view"] },
  { to: "/calendario", label: "Calendario", icon: CalendarRange, perm: ["bookings", "view"] },
  { to: "/notifiche", label: "Notifiche", icon: Bell },
  { to: "/report", label: "Report ed esportazioni", icon: FileDown, perm: ["reports", "export"] },
  { to: "/fatture", label: "Fatture", icon: Receipt, perm: ["invoices", "view"] },
  { to: "/rimborsi", label: "Rimborsi spese", icon: Wallet, perm: ["reimbursements", "view"] },
  { to: "/documenti", label: "Documenti", icon: FolderOpen, perm: ["documents", "view"] },
  { to: "/verbali", label: "Verbali", icon: ScrollText, perm: ["minutes", "view"] },
  { to: "/statistiche", label: "Statistiche eventi", icon: BarChart3, perm: ["stats", "view"] },
  { to: "/membri", label: "Membri e ruoli", icon: Users, perm: ["members", "view"] },
  { to: "/registro", label: "Registro attività", icon: History, perm: ["audit", "view"] },
  { to: "/impostazioni", label: "Impostazioni", icon: Settings, perm: ["settings", "edit"] },
  { to: "/profilo", label: "Il mio profilo", icon: UserCircle },
  { to: "/piattaforma", label: "Piattaforma", icon: ShieldCheck, superAdmin: true },
];

export const useNavItems = (can, user) =>
  NAV.filter((n) => (n.superAdmin ? user?.platform_role === "super_admin" : !n.perm || can(...n.perm)));
